export const loader_quotes = [
  "Stiamo analizzando le tue risposte...",
  "Valutiamo i tuoi interessi per proporti i percorsi migliori...",
  "Calcoliamo i costi dei vari percorsi di studio...",
  "Stiamo stimando il tuo guadagno futuro in base ai possibili percorsi...",
  "Confrontiamo i diversi percorsi accademici disponibili...",
  "Analizziamo le opportunità di lavoro legate ai tuoi interessi...",
  "Ti mostriamo come potrebbe essere il tuo futuro accademico e lavorativo...",
  "Prepariamo un quadro completo dei costi e benefici per te...",
  "Stiamo costruendo la tua guida personalizzata per il futuro...",
  "Quasi fatto! Presto scoprirai i migliori percorsi di studio per te..."
  ];
  